import type { Database } from "../../../__definitions__/database-definitions";
import { SupabaseServiceView } from "../../../server/supabase/base-supabase-service";

export type FollowUp = Database["public"]["Tables"]["follow_up"]["Row"];

export class SupabaseFollowUpMomentDetailsService extends SupabaseServiceView<"follow_up_moment_details"> {
  table = "follow_up_moment_details" as const;
}
